"use strict";

(() => {
  window.zag = window.zag || {};

  class HeroExternalVideoManager {
    constructor(section) {
      this.section = section;
      this.init();
    }

    get videoContainers() {
      return this.section?.querySelectorAll(".hero-external-video");
    }

    init() {
      if (!this.section || !this.videoContainers?.length) return;
      this.injectIframes();
    }

    parseVideoUrl(url) {
      if (!url) return null;

      const ytMatch = url.match(
        /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/
      );
      if (ytMatch) return { platform: "youtube", id: ytMatch[1] };

      const vimeoMatch = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (vimeoMatch) return { platform: "vimeo", id: vimeoMatch[1] };

      return null;
    }

    buildEmbedUrl(videoInfo, { autoplay = false, loop = false } = {}) {
      if (!videoInfo) return null;

      if (videoInfo.platform === "youtube") {
        const params = new URLSearchParams({
          mute: "1",
          autoplay: autoplay ? "1" : "0",
          loop: loop ? "1" : "0",
          controls: "1",
          rel: "0",
          modestbranding: "1",
          playsinline: "1",
        });
        if (loop) {
          /* YouTube requires playlist param equal to video id for loop to work */
          params.set("playlist", videoInfo.id);
        }
        return `https://www.youtube.com/embed/${videoInfo.id}?${params.toString()}`;
      }

      if (videoInfo.platform === "vimeo") {
        const params = new URLSearchParams({
          muted: "1",
          autoplay: autoplay ? "1" : "0",
          loop: loop ? "1" : "0",
          controls: "1",
          byline: "0",
          portrait: "0",
          title: "0",
        });
        return `https://player.vimeo.com/video/${videoInfo.id}?${params.toString()}`;
      }

      return null;
    }

    injectIframes() {
      this.videoContainers.forEach((container) => {
        const rawUrl = container.dataset.videoUrl;
        const autoplay = container.dataset.autoplay === "true";
        const loop = container.dataset.loop === "true";

        const videoInfo = this.parseVideoUrl(rawUrl);
        const embedUrl = this.buildEmbedUrl(videoInfo, { autoplay, loop });

        if (!embedUrl) return;

        const iframe = document.createElement("iframe");
        iframe.src = embedUrl;
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute(
          "allow",
          "autoplay; fullscreen; picture-in-picture"
        );
        iframe.setAttribute("allowfullscreen", "");
        iframe.setAttribute("loading", "lazy");
        iframe.setAttribute("title", "Video");

        container.appendChild(iframe);
      });
    }

    destroy() {}
  }

  const initHeroExternalVideo = () => {
    const sections = document.querySelectorAll(
      ".shopify-section--hero-external-video"
    );
    sections.forEach((section) => {
      if (section && !section.heroExternalVideoManager) {
        section.heroExternalVideoManager = new HeroExternalVideoManager(
          section
        );
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHeroExternalVideo);
  } else {
    initHeroExternalVideo();
  }

  document.addEventListener("shopify:section:load", (event) => {
    if (
      event.target.classList.contains(
        "shopify-section--hero-external-video"
      )
    ) {
      if (event.target.heroExternalVideoManager) {
        event.target.heroExternalVideoManager.destroy();
      }
      event.target.heroExternalVideoManager = new HeroExternalVideoManager(
        event.target
      );
    }
  });

  document.addEventListener("shopify:section:unload", (event) => {
    if (event.target.heroExternalVideoManager) {
      event.target.heroExternalVideoManager.destroy();
      delete event.target.heroExternalVideoManager;
    }
  });
})();
